<script>
	const userContext = require('core/userContext');
	const scrollManager = require('ui/core/scrollManager');
	const QuestionNavMixin = require('./question-nav-mixin');
	const { assetUrl } = require('utilities/urlUtilities');

	module.exports = {
		components: {
			'vocabulary-image-list': require('components/vocabulary-image-list.vue').default,
			'question-text': require('components/question-text.vue').default,
			'text-to-speech-player-simple': require('components/text-to-speech-player-simple.vue').default,
			'tab-container': require('components/tab-container.vue').default
		},
		mixins: [QuestionNavMixin],
		props: [
			'question-sets-ordered-and-filtered',
			'route-context',
			'workspace',
			'assignment-done',
			'assignment-submitted',
			'product',
			'questions-blurb',
			'assignment-id',
			'submit-assignment',
			'assignmentPastDeadline',
			'onNextQuestionSet'
		],
		modelData: ['qset'],
		data: function () {
			return {
				qsetTabKey: 'qset',
				studentName: '',
				isTeacher: !userContext.isStudent()
			};
		},
		mounted() {
			this.studentName = userContext.getFullName();
		},
		computed: {
			assignmentClosed() {
				let assignmentDone = this.assignmentDone;
				let assignmentSubmitted = this.assignmentSubmitted;
				let assignmentClosed = assignmentDone || assignmentSubmitted;

				return assignmentClosed;
			},
			showGeneralFeedback() {
				const qs = this.qs;
				const assignmentClosed = this.assignmentClosed;
				const scoreState = this.workspace.scoreState;
				const hasScoreStateFeedback = scoreState && scoreState.f;
				const hasFeedback = this.hasNote(qs.qsid) || (hasScoreStateFeedback && scoreState.f[qs.qsid]);

				return !assignmentClosed && hasScoreStateFeedback && hasFeedback;
			}
		},
		methods: {
			scrollToNote: function (index) {
				scrollManager(
					$('[data-note=' + index + ']'),
					{
						duration: 500,
						priority: 0
					},
					this.$el
				);
			},
			hasNote: function (qsId) {
				const q = this.workspace.scoreState.q;

				if (!q) {
					return false;
				}

				for (var key in q[qsId]) {
					if (q[qsId][key].f) {
						return true;
					}
				}

				return false;
			},
			onSubmitClick(event) {
				if (this.atLastQuestionSet) {
					this.submitAssignment(event);
				} else {
					this.nextQuestionSet(event);
				}
				if (this.onNextQuestionSet) {
					this.onNextQuestionSet();
				}
			},
			assetUrl(url) {
				return assetUrl(url);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.student-questions.main-content {
		max-width: $max-width-inner;
		margin-left: auto;
		margin-right: auto;

		> .well {
			> ol {
				margin: 0.25rem;
			}
		}

		.general-feedback-container {
			border-left: 1px solid $c-grey;
			padding-left: $size-medium;

			h4 {
				margin-top: $size-xs;
			}
		}

		.question-set-header {
			.padding-right-medium {
				padding-right: $size-medium;
			}

			.question-set-subheader {
				margin-top: 1rem;

				> * {
					display: inline-block;
				}

				h3 {
					margin-top: 0rem;
				}

				.auto-save {
					float: right;
					margin-top: 0.5rem;
				}
			}
		}
	}
</style>
<template>
	<form
		class="main-content student-questions"
		:class="{ 'main-content-non-aad': product.productType !== 'AAD' }"
		@submit.prevent="onSubmitClick">
		<div
			class="well"
			v-if="workspace.opts.qs.length > 1">
			<h2 v-show="assignmentSubmitted">You've submitted this assignment.</h2>
			<h2 v-show="assignmentDone && !assignmentSubmitted">This assignment time is over.</h2>
			<template v-if="questionsBlurb.count > 1">
				<h3>{{ questionsBlurb.blurb }}</h3>
				<tab-container
					model-key="qset"
					:tabs="questionSetsOrderedAndFiltered">
					<li
						v-for="qset in questionSetsOrderedAndFiltered"
						:key="qset.qsId">
						<a
							:data-tab="qset.qsid"
							v-html="qset.title"></a>
					</li>
				</tab-container>
			</template>
		</div>
		<div
			class="question-set"
			v-if="qs"
			ref="qsetPanel"
			:data-panel="qs.qsid">
			<header class="question-set-header row">
				<div
					class="columns small-12"
					:class="{
						'large-8': showGeneralFeedback,
						'padding-right-medium': showGeneralFeedback
					}">
					<h2
						id="question-set-title"
						v-html="qs.title"></h2>
					<div class="question-set-subheader">
						<h3>{{ assignedQuestions.length }} {{ assignedQuestions.length === 1 ? 'question' : 'questions' }}</h3>
						<div
							class="auto-save font-small text-muted"
							v-if="workspace.s !== 's' && !workspace.closed && !assignmentPastDeadline && (wsTab === QUESTIONS_VIEW || wsTab === BOOK_OF_KNOWLEDGE_VIEW)">
							Your work is automatically saved.
						</div>
					</div>
				</div>
				<div
					v-if="showGeneralFeedback"
					class="columns small-12 large-4 general-feedback-container">
					<h4>Teacher Feedback</h4>
					<div class="general-feedback">
						{{ workspace.scoreState.f[qs.qsid] }}
					</div>
					<div
						v-if="hasNote(qs.qsid)"
						class="margin-top-medium margin-bottom-medium">
						<template v-for="(q, questionIndex) in assignedQuestions">
							<img
								style="cursor: pointer"
								v-on:click="scrollToNote(questionIndex)"
								v-if="workspace.scoreState.q[qs.qsid][q.qid].f"
								class="margin-right-small"
								:src="assetUrl('/assets/dist/images/icon-note-active-' + (questionIndex + 1) + '.svg')" />
						</template>
					</div>
				</div>
			</header>
			<!-- end .question-set-header -->
			<div class="question-set-questions -student">
				<div
					class="directions"
					v-if="qs.studentIntro">
					<question-text
						:content="qs.studentIntro"
						show-tts
						:event-data="{ qsid: qs.qsid, tag: 'student_intro' }">
					</question-text>
				</div>
				<template v-if="qs.studentIntroImages">
					<vocabulary-image-list
						:images="qs.studentIntroImages"
						:word="qs.vocabularyWord">
					</vocabulary-image-list>
				</template>
				<ol
					class="question-list"
					aria-labelledby="question-set-title">
					<li
						v-for="(q, index) in assignedQuestions"
						:key="q.qid"
						class="row question-row"
						:data-note="index">
						<div
							class="columns small-12"
							:class="{
								'large-8': !assignmentClosed && workspace.scoreState.q && workspace.scoreState.q[qs.qsid][q.qid].f
							}">
							<div
								class="directions"
								v-if="qs.directions && qs.directions[index + 1]">
								<span v-html="qs.directions[index + 1]"></span>.
								<text-to-speech-player-simple
									:text="qs.directions[index + 1]"
									:event-data="{ qsid: qs.qsid, tag: 'question_instructions' }">
								</text-to-speech-player-simple>
							</div>
							<!--
							submitted assignments:
							- no score-state - so no indication of student answer
							- disable-input - so clicks won't respond
							- show-as-inactive - so controls are greyed out
						-->
							<template v-if="isTeacher || workspace.s === 's' || workspace.closed">
								<student-workspace-question
									show-as-inactive
									disable-input
									:q="q"
									:qsid="qs.qsid"
									:aid="assignmentId"
									:ws="workspace"
									:qnumb="index + 1"
									show-tts></student-workspace-question>
							</template>
							<!--
							un-submitted assignments:
							- score-state - student answer shown
							- no disable-input - clicks and input will respond
							- no show-as-inactive - so controls are NOT greyed out
						-->
							<template v-if="!isTeacher && workspace.s !== 's' && !workspace.closed">
								<student-workspace-question
									:q="q"
									:qsid="qs.qsid"
									:aid="assignmentId"
									:score-state.sync="workspace.scoreState.q[qs.qsid][q.qid]"
									:ws="workspace"
									:qnumb="index + 1"
									show-tts></student-workspace-question>
							</template>
						</div>
						<div
							class="columns small-12 large-4"
							v-if="!assignmentClosed && workspace.scoreState.q && workspace.scoreState.q[qs.qsid][q.qid].f">
							<img :src="assetUrl('/assets/dist/images/icon-note-active-' + (index + 1) + '.svg')" />
							<span style="font-weight: normal">{{ workspace.scoreState.q[qs.qsid][q.qid].f }}</span>
						</div>
					</li>
				</ol>
			</div>
			<!-- end .question-set-questions -->
			<button
				v-if="workspace.s === 'a' && !workspace.closed"
				type="submit"
				class="button -large -loading-to-right center">
				<template v-if="atLastQuestionSet"> Submit </template>
				<template v-if="!atLastQuestionSet"> Next &rarr; </template>
			</button>
		</div>
		<!-- end .question-set -->
	</form>
</template>
